import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'

import withToast from 'src/components/Toast'
import EmailConfirm from './EmailConfirm'

export default withRouter(injectIntl(withToast(EmailConfirm)))
